import { runTransaction, doc } from 'firebase/firestore';
import { db } from './firebase';

// Physical paper slips already have a staff-handwritten serial (e.g. "0259").
// Bookings that start on the website never have one, so we mint a "W"-prefixed
// serial here — the prefix alone tells staff at a glance whether a booking
// came from the paper booklet or the site. Firestore retries this transaction
// automatically if two submissions race for the same counter doc, so
// concurrent bookings can never receive the same number.
export async function getNextWebSerial() {
  const counterRef = doc(db, 'counters', 'web');
  const next = await runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);
    const current = snap.exists() ? snap.data().lastNumber : 0;
    const n = current + 1;
    tx.set(counterRef, { lastNumber: n }, { merge: true });
    return n;
  });
  return `W${String(next).padStart(4, '0')}`;
}
